import IComponent from "components/commons/IComponent";
import SwitchTabs from "components/commons/SwitchTabs";
import "./Views.css";
import Legend from "@arcgis/core/widgets/Legend";
import GetArcGISToken from "utils/GetArcGISToken";

let STR_LEGEND_TEXT_FULL = [
  "Basemap",
  "Overlay",
  "2D Map layer",
  "3D Map Layer",
];
class LegendPanel extends IComponent {
  legendSpawnArea = null;
  curLegendWidget = null;
  layer3DListWatch = null;
  legendTitle = null;
  constructor(props) {
    super(props);
    this.state = {};
    this.legendSpawnArea = this.createRef();
    this.legendTitle = STR_LEGEND_TEXT_FULL.concat([]);
    if (!GetArcGISToken.user.isAdmin) this.legendTitle.shift();
    if (!props.is3D) this.legendTitle.pop();
  }
  componentWillMount() {
    setTimeout(() => this.createLegendWidgets(0));
  }

  componentDidMount() {
    if (this.props.showSplitScreen) {
      let panel = document
        .querySelector(".LegendPanel")
        .querySelector(".ListTitle");
      panel.innerHTML = "LEGEND (RIGHT SIDE MAP)";
    }
  }
  createLegendWidgets(index) {
    this.curLegendWidget && this.curLegendWidget.destroy();
    this.layer3DListWatch && this.layer3DListWatch.remove();
    this.layerLists = this.$config.AvailLayerList;
    let layerInfos = null;
    let layerType = this.legendTitle[index];
    switch (layerType) {
      case "Basemap":
        layerInfos = {
          layer: this.$config.mapList.basemaps[0].layer,
        };
        break;
      case "Overlay":
        layerInfos = {
          layer: this.props.mapView.map.layers.find(
            (i) => i.title == "Overlays"
          ),
        };
        break;
      case "2D Map layer":
        layerInfos = {
          layer: this.props.mapView.map.layers.find(
            (i) => i.title == "2D Layers"
          ),
        };
        break;
      case "3D Map Layer":
        var layer3DGroup = this.props.mapView.map.layers.find(
          (i) => i.title === "3D Layers"
        );
        this.layer3DListWatch = layer3DGroup.layers.watch(
          "length",
          (newV, oldV) => this.refresh3DList()
        );
        break;
      default:
        break;
    }
    layerInfos = [layerInfos];
    var legendContainer = document.createElement("DIV");
    this.legendSpawnArea.current.appendChild(legendContainer);
    var widget = new Legend({
      view: this.props.mapView,
      layerInfos,
      basemapLegendVisible: true,
    });
    widget.container = legendContainer;
    this.curLegendWidget = widget;
    layerType === "3D Map Layer" && this.refresh3DList();
  }

  refresh3DList() {
    var layer3DGroup = this.props.mapView.map.layers.find(
      (i) => i.title === "3D Layers"
    );
    this.curLegendWidget.layerInfos = [{ layer: layer3DGroup }];
  }

  componentWillUnmount() {
    console.debug("Unmount Legend Panel");
    this.curLegendWidget && this.curLegendWidget.destroy();
  }
  handleTabClick(legendIndex) {
    this.createLegendWidgets(legendIndex);
    this.setState({});
  }
  render() {
    return (
      <div className="LegendPanel">
        <div
          className="ListTitle"
          style={{ paddingTop: "15px", letterSpacing: "2px" }}
        >
          LEGEND
        </div>
        <div>
          <SwitchTabs
            tabText={this.legendTitle}
            onSwitchTabCallback={(e) => this.handleTabClick(e)}
          />
        </div>
        <div className="LegendItem" ref={this.legendSpawnArea} />
      </div>
    );
  }
}

export default LegendPanel;
